import { useState, useEffect, forwardRef } from "react";
import ReactDOM from "react-dom";

const FormCell = forwardRef((props, ref) => {
  const [page, setPage] = useState(null);

  useEffect(() => {
    const el = document.getElementById(props.pageId);
    if (el) setPage(el);
  }, [props.pageId]);


  
  const render = (props) => {
    return props.children;
  }
  
  // if there is a container id, render in the container
  // if no container id, render onto
  if(props.pageId) {
    if (!page) return null; //the target element isn't ready yet
    return ReactDOM.createPortal(
      props.children,
      page
    );

  } else {
    
    return (props.children);

  }
});

export default FormCell;